import React, { useState } from 'react';
import FetchIndicator from "./FetchIndicator"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import "./IndicatorTable.css"



function IndicatorTable() {
  const [values, setValues] = useState(Array.from({ length: 5 }, () => Array.from({ length: 5 }, () => '')));
  const [singleValue, setSingleValue] = useState('');
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isClicked, setisClicked] = useState(false);



   //Functions for the table that gets user input
  const handleTableChange = (rowIndex, columnIndex, value) => {
    const newValues = [...values];
    newValues[rowIndex][columnIndex] = value;
    setValues(newValues);

    const rowSums = newValues.map(row => row.reduce((acc, curr) => acc + parseInt(curr), 0));
    const isTableFilled = newValues.every(row => row.every(value => value !== ''));
    const isSingleValueFilled = singleValue !== '';
    const isSumEqual = rowSums.every(sum => sum === parseInt(singleValue));
    setIsSubmitDisabled(!isTableFilled || !isSingleValueFilled || !isSumEqual);
  };

  const handleSingleValueChange = (value) => {
    setSingleValue(value);

    const isTableFilled = values.every(row => row.every(value => value !== ''));
    const isSingleValueFilled = value !== '';
    setIsSubmitDisabled(!isTableFilled || !isSingleValueFilled);
  };

  const handleSubmit = () => {
    setisClicked(true)
  };




  const [hoveredItem, setHoveredItem] = useState('');

  const handleMouseEnter = (item) => {
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem('');
  };

  const cellStyle = {
    padding: '3x', // Adjust the padding value as needed
    fontSize: '12px', // Adjust the font size as needed
    textAlign: 'center',
  };

  const tableStyle = {
    padding: '3px', // Adjust the padding value as needed
    marginRight: "1%",
    marginLeft: "0%"
  };



  return (
    <div style = {{marginBottom: "10%", marginTop: "10%"}} className="my-table">
      <div style = {{display: "flex"}}>
          <table style = {{marginRight: "1%"}}>
            <thead>
              <tr>
                <th>Δείκτης αξιολόγησης</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Ικανοποίηση με Δημόσιες Συγκοινωνίες</td>
              </tr>
            </tbody>
          </table>



          <table  style={tableStyle}>
            <thead>
              <tr>
                <th>Τίτλος</th>
              </tr>
            </thead>
            <tbody>
              <tr
                onMouseEnter={() => handleMouseEnter('Affordable')}
                onMouseLeave={handleMouseLeave}
              >
                <td>{hoveredItem === 'Affordable' ? <div className='table-popup'>
                      <p>Αφορά στο βαθμό αντίληψης των χρηστών πως το μεταφορικό μέσο είναι οικονομικά προσιτό (Δημόσιες Συγκοινωνίες). Για μετακίνηση με Ι.Χ. επιβατικό αυτοκίνητο αφορά στο αντιληπτό επίπεδο άνεσης των μετακινούμενων.
                      </p></div> 
                      : <div style = {{display: "flex"}}> Affordable<FontAwesomeIcon icon={faCircleQuestion} /> </div>}
                      </td>
              </tr>
              <tr
                onMouseEnter={() => handleMouseEnter('Safe')}
                onMouseLeave={handleMouseLeave}
              >
                <td>{hoveredItem === 'Safe' ? <div className='table-popup'>
                      <p>Αφορά στο βαθμό αντίληψης των χρηστών πως το μεταφορικό μέσο είναι ασφαλές.</p></div> : 
                      'Safe'}  <FontAwesomeIcon icon={faCircleQuestion} /></td>
              </tr>
              <tr
                onMouseEnter={() => handleMouseEnter('Access')}
                onMouseLeave={handleMouseLeave}
              >
                <td>{hoveredItem === 'Access' ? <div className='table-popup'>
                      <p>Αφορά στο βαθμό αντίληψης των χρηστών πως το μεταφορικό μέσο είναι εύκολα προσβάσιμο (Δημόσιες Συγκοινωνίες). Για μετακίνηση με Ι.Χ. επιβατικό αυτοκίνητο αφορά στο αντιληπτό επίπεδο αυτονομίας προς τους χρήστες που προσφέρει.</p></div>
                      : 'Access'}  <FontAwesomeIcon icon={faCircleQuestion} /></td>
              </tr>
              <tr
                onMouseEnter={() => handleMouseEnter('Frequent')}
                onMouseLeave={handleMouseLeave}
              >
                <td>{hoveredItem === 'Frequent' ? <div className='table-popup'>
                      <p>Αφορά στο βαθμό αντίληψης των χρηστών πως το μεταφορικό μέσο είναι διαθέσιμο στη συχνότητα που δηλώνεται από το διαχειριστή του (Δημόσιες Συγκοινωνίες). Για τις μετακινήσεις με Ι.Χ. επιβατικό αυτοκίνητο αφορά στον απαιτούμενο χρόνο μετακίνησης.</p></div> 
                      : 'Frequent'}  <FontAwesomeIcon icon={faCircleQuestion} /></td>
              </tr>
              <tr
                onMouseEnter={() => handleMouseEnter('Reliable')}
                onMouseLeave={handleMouseLeave}
              >
                  <td>{hoveredItem === 'Reliable' ? <div className='table-popup'>
                      <p>Αφορά στο βαθμό αντίληψης των χρηστών πως το μεταφορικό μέσο είναι αξιόπιστο με όρους που αφορούν στη μεταφορά των μετακινούμενων στο χρόνο που δηλώνεται από το διαχειριστή του στην περίπτωση μέσων Δημόσιας Συγκοινωνίας ή στο χρόνο που απαιτείται συνήθως για τη μετακίνηση με Ι.Χ. επιβατικό αυτοκίνητο</p></div>
                      : 'Reliable'}  <FontAwesomeIcon icon={faCircleQuestion} /></td>
              </tr>
            </tbody>
          </table>





         {/* READ USER INPUT */}
        <table style={tableStyle}>
          <thead>
              <tr>
                <th style={cellStyle}>Αρ. δείγματος</th>
              </tr>
          </thead>
          <tbody>
            <tr>
              <td style={cellStyle}>
                <input
                  type="number"
                  min="1"
                  step="1"
                  value={singleValue}
                  onChange={e => handleSingleValueChange(e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>



        {/* READ USER INPUT */}
          <table style={tableStyle}>
            <thead>
            <tr>
                <th style={cellStyle}>Δεν απαντώ</th>
                <th style={cellStyle}>Συμφωνώ απόλυτα</th>
                <th style={cellStyle}>Συμφωνώ μερικώς</th>
                <th style={cellStyle}>Διαφωνώ μερικώς</th>
                <th style={cellStyle}>Διαφωνώ απόλυτα</th>
              </tr>
            </thead>
            <tbody>
              {values.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((value, columnIndex) => (
                    <td key={columnIndex} style={cellStyle}>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        value={value}
                        onChange={e => handleTableChange(rowIndex, columnIndex, e.target.value)}
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {isSubmitDisabled === false && isClicked ===true ?<FetchIndicator samples = {singleValue} table_data = {values} ></FetchIndicator>:<></>}
        <button disabled={isSubmitDisabled} onClick={handleSubmit} style = {{marginTop: "5%", marginLeft: "50%"}}>Υπολογισμός</button>




    </div>
  );
}

export default IndicatorTable;
